var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnDesassociarDespViagem)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Desassociar Despesa de Viagem"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDesassociarDespViagem(
                _vm.finalizacaoDespViagem.finalizacaoDespViagemId
            )}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }